/* Oergezond welkomst-popup: 15 s of exit intent, Klaviyo-inschrijving, WELKOM10 automatisch toepassen. */
(function () {
  var C = window.lxPopup || {};
  var pop = document.getElementById('lx-pop');
  if (!pop) return;
  var KEY_DONE = 'lx_pop_subscribed', KEY_SEEN = 'lx_pop_closed_at', COOLDOWN = 7 * 24 * 3600 * 1000;

  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function blocked() {
    if (store(KEY_DONE)) return true;
    var t = +store(KEY_SEEN); if (t && Date.now() - t < COOLDOWN) return true;
    try { if (sessionStorage.getItem('lx_pop_shown')) return true; } catch (e) {}
    if (/[?&](utm_medium=email|_kx=)/.test(location.search)) return true; // komt uit een Klaviyo-mail
    return false;
  }

  var shown = false;
  function open() {
    if (shown || blocked()) return;
    if (document.querySelector('.kaching-cart.active, .kaching-cart--open')) return; // niet over de winkelmand heen
    shown = true;
    try { sessionStorage.setItem('lx_pop_shown', '1'); } catch (e) {}
    pop.hidden = false; pop.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { pop.classList.add('lx-on'); });
    document.documentElement.classList.add('lx-pop-lock');
    var f = pop.querySelector('input[name=first_name]'); setTimeout(function () { if (f && window.innerWidth > 749) f.focus(); }, 300);
  }
  function close() {
    pop.classList.remove('lx-on'); pop.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lx-pop-lock');
    if (!store(KEY_DONE)) store(KEY_SEEN, String(Date.now()));
    setTimeout(function () { pop.hidden = true; }, 250);
  }
  pop.querySelectorAll('[data-lx-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });

  /* triggers */
  if (!blocked()) {
    setTimeout(open, C.delay || 15000);
    // desktop: muis gaat de bovenkant uit
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 4 && window.innerWidth > 749) open();
    });
    // mobiel: snel terug omhoog scrollen na eerst flink naar beneden te zijn gegaan
    var maxY = 0, lastY = window.scrollY, lastT = Date.now();
    window.addEventListener('scroll', function () {
      var y = window.scrollY, t = Date.now();
      maxY = Math.max(maxY, y);
      var v = (lastY - y) / Math.max(1, t - lastT); // px per ms omhoog
      if (window.innerWidth <= 749 && maxY > 1200 && v > 1.6 && y < maxY - 400) open();
      lastY = y; lastT = t;
    }, { passive: true });
  }

  /* inschrijven */
  var form = pop.querySelector('.lx-pop-form'), err = pop.querySelector('.lx-pop-err'), btn = form.querySelector('button');
  function showErr(m) { err.textContent = m; err.hidden = false; }
  form.addEventListener('submit', function (e) {
    e.preventDefault(); err.hidden = true;
    var name = form.first_name.value.trim(), email = form.email.value.trim();
    if (!name) return showErr('Vul je voornaam in.');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return showErr('Vul een geldig e-mailadres in.');
    btn.disabled = true; btn.classList.add('lx-busy');
    var body = { data: { type: 'subscription', attributes: {
      custom_source: 'Oergezond popup WELKOM10',
      profile: { data: { type: 'profile', attributes: { email: email, first_name: name,
        properties: { signup_source: 'website popup', welkom_code: C.code },
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
      relationships: { list: { data: { type: 'list', id: C.listId } } } } };
    // Inschrijven op de nieuwsbrief + de lijst waar de welkomstflow op start (C.welcomeListId).
    function subscribe(listId) {
      var b = JSON.parse(JSON.stringify(body));
      b.data.relationships = { list: { data: { type: 'list', id: listId } } };
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(C.companyId), {
        method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2025-07-15' }, body: JSON.stringify(b)
      });
    }
    var lists = [C.listId].concat(C.welcomeListId ? [C.welcomeListId] : []);
    Promise.all(lists.map(subscribe)).then(function (rs) {
      var r = rs[0];
      if (!r.ok && r.status !== 202) throw new Error('klaviyo ' + r.status);
      return fetch('/discount/' + encodeURIComponent(C.code), { credentials: 'same-origin' });
    }).then(function () {
      store(KEY_DONE, '1');
      try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email, first_name: name }); } catch (x) {}
      pop.querySelector('[data-lx-name]').textContent = name;
      pop.querySelector('[data-step=form]').hidden = true;
      pop.querySelector('[data-step=done]').hidden = false;
    }).catch(function () {
      showErr('Er ging iets mis. Probeer het nog eens.');
    }).then(function () { btn.disabled = false; btn.classList.remove('lx-busy'); });
  });

  var copy = pop.querySelector('[data-lx-copy]');
  if (copy) copy.addEventListener('click', function () {
    try { navigator.clipboard.writeText(C.code); copy.textContent = 'Gekopieerd'; } catch (e) {}
  });

  window.lxOpenPopup = function () { shown = false; try { sessionStorage.removeItem('lx_pop_shown'); localStorage.removeItem(KEY_SEEN); } catch (e) {} open(); };
})();
